import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  useStravaAnalytics,
  useStravaErrorLogging,
  useStravaTranslations
} from '@strava/container-context';
import ProfileEveryone from './components/ProfileEveryone';
import ProfileFollowersOnly from './components/ProfileFollowersOnly';
import { LoggedOutAthletePageContextProvider } from './state/LoggedOutAthletePageContext';
import { athleteDataProps } from './prop-types';

export const LOAP_I18N_PREFIX = 'logged_out_athlete_page_ui';
export const LOAP_BRANCH_FEATURE = 'athlete show';

const LoggedOutAthletePage = ({ athleteData, isFollowersOnly }) => {
  const { track: _track } = useStravaAnalytics();
  const { logError } = useStravaErrorLogging();
  const { t: _t, getLanguage } = useStravaTranslations();
  const { analyticsData } = athleteData;
  const { category, page } = analyticsData;

  const locale = getLanguage();

  // override analytics helper function
  const track = useCallback(
    (fields = {}) => {
      _track({
        category,
        page,
        ...fields
      });
    },
    [_track, category, page]
  );

  // override translations helper function
  const t = useMemo(
    () => (key, params) => _t(`${LOAP_I18N_PREFIX}.${key}`, { ...params }),
    [_t]
  );

  const providerState = useMemo(
    () => ({
      t,
      track,
      state: {
        i18nPrefix: LOAP_I18N_PREFIX,
        locale,
        athleteData
      },
      logError
    }),
    [t, track, locale, athleteData, logError]
  );

  return (
    <LoggedOutAthletePageContextProvider value={providerState}>
      {isFollowersOnly ? <ProfileFollowersOnly /> : <ProfileEveryone />}
    </LoggedOutAthletePageContextProvider>
  );
};

LoggedOutAthletePage.propTypes = {
  athleteData: athleteDataProps.isRequired,
  isFollowersOnly: PropTypes.bool.isRequired
};

export default LoggedOutAthletePage;
